import { render, staticRenderFns } from "./ChartistChart.vue?vue&type=template&id=0b3a31dc"
import script from "./ChartistChart.vue?vue&type=script&lang=js"
export * from "./ChartistChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports